import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane, faTimes } from "@fortawesome/free-solid-svg-icons";

const FloatingMessage = ({ message, onClick }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), 4000);
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <div
      onClick={onClick}
      style={{
        position: "fixed",
        left: "16px",
        bottom: "90px",
        maxWidth: "280px",
        backgroundColor: "rgba(0, 0, 0, 0.85)",
        borderRadius: "12px",
        padding: "10px 14px",
        zIndex: 250,
        cursor: "pointer",
        animation: "fadeInUp 0.3s ease",
      }}
    >
      <div
        style={{
          color: "rgba(255,255,255,0.5)",
          fontSize: "11px",
          fontWeight: "600",
          marginBottom: "4px",
        }}
      >
        Message
      </div>
      <div
        style={{
          color: "#fff",
          fontSize: "14px",
          wordBreak: "break-word",
        }}
      >
        {message.text}
      </div>
    </div>
  );
};

const ChatPanel = ({
  messages,
  onSend,
  isOpen,
  onClose,
  currentSender,
  lastReceivedMessage,
}) => {
  const [inputText, setInputText] = useState("");
  const messagesEndRef = useRef(null);

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (inputText.trim()) {
      onSend(inputText);
      setInputText("");
    }
  };

  if (!isOpen) {
    return lastReceivedMessage ? (
      <FloatingMessage message={lastReceivedMessage} onClick={onClose} />
    ) : null;
  }

  return (
    <div
      style={{
        position: "fixed",
        left: 0,
        bottom: "80px",
        width: "320px",
        maxHeight: "400px",
        backgroundColor: "rgba(0, 0, 0, 0.85)",
        zIndex: 240,
        borderRadius: "0 12px 0 0",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 14px",
          borderBottom: "1px solid rgba(255,255,255,0.2)",
        }}
      >
        <span style={{ color: "#fff", fontWeight: "600", fontSize: "14px" }}>
          Chat
        </span>
        <div
          style={{ cursor: "pointer", color: "#fff", padding: "4px" }}
          onClick={onClose}
        >
          <FontAwesomeIcon icon={faTimes} />
        </div>
      </div>

      <div
        style={{
          flex: 1,
          overflowY: "auto",
          padding: "10px 14px",
          minHeight: "200px",
        }}
      >
        {messages.map((msg, idx) => (
          <div
            key={idx}
            style={{
              marginBottom: "8px",
              textAlign: msg.sender === currentSender ? "right" : "left",
            }}
          >
            <div
              style={{
                display: "inline-block",
                padding: "6px 12px",
                borderRadius: "12px",
                backgroundColor:
                  msg.sender === currentSender
                    ? "rgba(0, 120, 255, 0.8)"
                    : "rgba(255, 255, 255, 0.2)",
                color: "#fff",
                fontSize: "13px",
                maxWidth: "80%",
                wordBreak: "break-word",
              }}
            >
              {msg.text}
            </div>
            <div
              style={{
                fontSize: "10px",
                color: "rgba(255,255,255,0.5)",
                marginTop: "2px",
              }}
            >
              {new Date(msg.timestamp).toLocaleTimeString("fr-FR", {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </div>
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>

      <form
        onSubmit={handleSubmit}
        style={{
          display: "flex",
          padding: "8px",
          borderTop: "1px solid rgba(255,255,255,0.2)",
        }}
      >
        <input
          type="text"
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
          placeholder="Message..."
          style={{
            flex: 1,
            padding: "8px 12px",
            borderRadius: "20px",
            border: "none",
            outline: "none",
            fontSize: "16px",
            backgroundColor: "rgba(255,255,255,0.15)",
            color: "#fff",
          }}
        />
        <button
          type="submit"
          style={{
            marginLeft: "6px",
            backgroundColor: "transparent",
            border: "none",
            color: "#fff",
            cursor: "pointer",
            padding: "8px",
            fontSize: "14px",
          }}
        >
          <FontAwesomeIcon icon={faPaperPlane} />
        </button>
      </form>
    </div>
  );
};

export default ChatPanel;
